import classNames from 'classnames';
import IconButton from 'components/common/IconButton';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ProductContext } from 'context/Context';
import StarRating from 'components/common/StarRating';
import QuantityController from '../../QuantityController';
import { useProductHook } from 'hooks/useProductHook';
import { changeToCoin } from 'helpers/utils';
import ProductDetailsReferences from './ProductDetailsReferences';

const ProductDetailsMain = ({ product, setImgs }) => {
 const {
  _id,
  stock,
  article,
  pricingReference,
  name,
  categories,
  tags,
  price,
  regularPrice,
  shortDescription,
  reviews,
  rating,
  favorite
 } = product;

 const { isInFavouriteItems } = useContext(ProductContext);

 const [amount, setAmount] = useState(Math.min(pricingReference.map(e => e.price)) || regularPrice || price);
 const [productCount, setProductCount] = useState(article?.code ? 0 : 1);
 const [selectedRef, setSelectedRef] = useState([]);
 const [bolq, setBolq] = useState(!!article?.code);

 /* const referencePrices = pricingReference.map(e => ({
  ...e,
  references: article?.references.reduce((acc, b) => {
   const refs = b.properties.filter(u => e.references.some(s => s === u._id)).map(i => i._id);
   if (refs.length) acc.push({ ref: b.reference, items: refs });
   return acc;
  }, [])
 })); */

 useEffect(() => {
  if (!bolq) setProductCount(1);
  else setProductCount(0);
 }, [bolq]);

 useEffect(() => {
  /* const newPrice = referencePrices.find(e =>
   e.references.every(a => a.items.some(u => selectedRef.some(a => a._id === u)))
  )?.price;

  setAmount(newPrice ?? (regularPrice || price)); */

  setAmount(priceByReference(selectedRef));

  priceByReference(selectedRef);

  console.log({ selectedRef });
 }, [selectedRef]);

 const { priceByReference, handleAddToCart, handleFavouriteClick } = useProductHook(product);

 const handleQuantityChange = e => {
  setProductCount(parseInt(e.target.value < 1 ? 1 : e.target.value));
 };

 const handleQuantityIncrease = () => {
  setProductCount(productCount + 1);
 };

 const handleQuantityDecrease = () => {
  productCount > 1 && setProductCount(productCount - 1);
 };

 return (
  <>
   <h5>{name}</h5>
   <Link to="#!" className="fs--1 mb-2 d-block">
    {categories.slice(0, 3).join(' & ')}
   </Link>
   <div className="fs--2 mb-3 d-inline-block">
    <StarRating readonly rating={rating / reviews ?? 0} />
    <span className="ms-1 text-600">({rating ?? 0})</span>
   </div>
   {shortDescription && <p className="fs--1">{shortDescription}</p>}
   <h4 className="d-flex align-items-center">
    <span className="text-warning me-2">{changeToCoin({ amount, symbol: true, cents: true })}</span>
    {/* {price && (
     <span className="me-1 fs--1 text-500">
      <del className="me-1">{`$${price}`}</del>
      <strong>-{20}%</strong>
     </span>
    )} */}
   </h4>
   {/* <p className="fs--1 mb-1">
    <span>Financiacion: </span>
    <strong> 3 meses</strong>
   </p> */}
   <p className="fs--1">
    Stock:{' '}
    <strong
     className={classNames({
      'text-success': stock,
      'text-danger': !stock
     })}
    >
     {stock ? 'Disponible' : 'No-Disponible'}
    </strong>
   </p>
   {tags && (
    <p className="fs--1 mb-3">
     Tags:
     {tags?.map((tag, index) => (
      <Link
       to="#!"
       key={tag}
       className={classNames({
        'ms-2': index === 0,
        'ms-1': index > 0
       })}
      >
       {tag},
      </Link>
     ))}
    </p>
   )}

   {article?.code ? (
    <ProductDetailsReferences
     article={article}
     setImgs={setImgs}
     setBolq={setBolq}
     selectedRef={selectedRef}
     setSelectedRef={setSelectedRef}
    />
   ) : (
    <></>
   )}

   <Row className="mt-3 mt-mb-0">
    <Col xs="auto" className="pe-0">
     <div className="">
      <QuantityController
       bolq={bolq}
       quantity={productCount}
       handleChange={handleQuantityChange}
       handleIncrease={handleQuantityIncrease}
       handleDecrease={handleQuantityDecrease}
      />
     </div>
    </Col>
    <Col xs="auto" className="px-2 px-md-3">
     <IconButton
      iconClassName="me-sm-2"
      variant="primary"
      size="sm"
      icon="cart-plus"
      onClick={() => handleAddToCart(productCount, true, false, selectedRef)}
      disabled={bolq}
     >
      <span className="d-none d-sm-inline-block">Añadir Al Carrito</span>
     </IconButton>
    </Col>
    <Col xs="auto" className="px-0">
     <IconButton
      className="border-300"
      iconClassName="me-1"
      variant="outline-danger"
      size="sm"
      icon={isInFavouriteItems(_id) ? 'heart' : ['far', 'heart']}
      onClick={handleFavouriteClick}
     >
      {favorite ?? 0}
     </IconButton>
    </Col>
   </Row>
  </>
 );
};

ProductDetailsMain.propTypes = {
 product: PropTypes.shape({
  _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  article: PropTypes.object,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  rating: PropTypes.number.isRequired,
  reviews: PropTypes.number.isRequired,
  isInStock: PropTypes.bool,
  shortDescription: PropTypes.string,
  tags: PropTypes.array,
  type: PropTypes.string.isRequired,
  stock: PropTypes.oneOfType([PropTypes.any, PropTypes.number]),
  pricingReference: PropTypes.array.isRequired,
  code: PropTypes.string.isRequired,
  categories: PropTypes.array.isRequired,
  regularPrice: PropTypes.number.isRequired,
  favorite: PropTypes.number.isRequired,
  isFavorite: PropTypes.bool.isRequired
 }).isRequired,
 setImgs: PropTypes.func.isRequired
};

ProductDetailsMain.defaultProps = {
 product: {
  _id: '',
  name: '',
  article: {},
  price: 0,
  rating: 0,
  reviews: 1,
  isInStock: true,
  shortDescription: '',
  tags: [],
  type: 'product',
  stock: 1,
  pricingReference: [],
  code: '',
  categories: '',
  regularPrice: 0,
  favorite: 0,
  isFavorite: false
 }
};

export default ProductDetailsMain;
